module.exports = "<div class=\"grid-three-col mt-double\">\n\t<div class=\"col col-one-third\">\n        <md-card>\n    \t\t<general-info [entityIdDetails]=\"entityIdDetails\">Loading...</general-info>\n  \t\t</md-card>\n  \t</div>\n  \t<div class=\"col col-4\">\n\t\t<md-card>\n\t\t\t<address-information [entityIdDetails]=\"entityIdDetails\"></address-information>\n\t\t</md-card>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/details/entitydetailsperson/entity-details-person.component.html
// module id = 2205
// module chunks = 0